import {
  FETCH_AE_DETAILS,
  FETCH_AE_DETAILS_START,
  FETCH_AE_DETAILS_SUCCESS,
  FETCH_AE_DETAILS_ERROR,
  FETCH_AE_DETAILS_SELECTION,
  FETCH_AE_DETAILS_SELECTION_START,
  FETCH_AE_DETAILS_SELECTION_SUCCESS,
  FETCH_AE_DETAILS_SELECTION_ERROR,
  POST_AE_DETAILS,
  POST_AE_DETAILS_START,
  POST_AE_DETAILS_SUCCESS,
  POST_AE_DETAILS_ERROR,
  UPDATE_AE_DETAILS_CHANGE,
  RESET_AE_DETAILS_CHANGE,
  UPDATE_AE_RESOURCE_LEVEL_ID,
  UPDATE_PROJECT_HEALTH_ID,
  UPDATE_AE_NOTES,
  UPDATE_PROJECT_WAIVER
} from './constants'

const fetchAEDetails = (projectId) => ({ type: FETCH_AE_DETAILS, projectId })
const fetchAEDetailsStart = () => ({ type: FETCH_AE_DETAILS_START })
const fetchAEDetailsSuccess = () => ({ type: FETCH_AE_DETAILS_SUCCESS })
const fetchAEDetailsError = (error) => ({ type: FETCH_AE_DETAILS_ERROR, error })

const fetchAEDetailsSelection = () => ({ type: FETCH_AE_DETAILS_SELECTION })
const fetchAEDetailsSelectionStart = () => ({ type: FETCH_AE_DETAILS_SELECTION_START })
const fetchAEDetailsSelectionSuccess = () => ({ type: FETCH_AE_DETAILS_SELECTION_SUCCESS })
const fetchAEDetailsSelectionError = (error) => ({ type: FETCH_AE_DETAILS_SELECTION_ERROR, error })

const postAEDetails = (projectId, params) => ({ type: POST_AE_DETAILS, projectId, params })
const postAEDetailsStart = () => ({ type: POST_AE_DETAILS_START })
const postAEDetailsSuccess = () => ({ type: POST_AE_DETAILS_SUCCESS })
const postAEDetailsError = (error) => ({ type: POST_AE_DETAILS_ERROR, error })

const updateAEDetailsChange = (details) => ({ type: UPDATE_AE_DETAILS_CHANGE, details })
const resetAEDetailsChange = (details) => ({ type: RESET_AE_DETAILS_CHANGE, details })

const updateAeResourceLevelId = (id) => ({ type: UPDATE_AE_RESOURCE_LEVEL_ID, id })
const updateProjectHealthId = (id) => ({ type: UPDATE_PROJECT_HEALTH_ID, id })
const updateAeNotes = (notes) => ({ type: UPDATE_AE_NOTES, notes })
const updateProjectWaiver = (projectWaiver) => ({ type: UPDATE_PROJECT_WAIVER, projectWaiver })

export {
  fetchAEDetails,
  fetchAEDetailsStart,
  fetchAEDetailsSuccess,
  fetchAEDetailsError,
  fetchAEDetailsSelection,
  fetchAEDetailsSelectionStart,
  fetchAEDetailsSelectionSuccess,
  fetchAEDetailsSelectionError,
  postAEDetails,
  postAEDetailsStart,
  postAEDetailsSuccess,
  postAEDetailsError,
  updateAEDetailsChange,
  resetAEDetailsChange,
  updateAeResourceLevelId,
  updateProjectHealthId,
  updateAeNotes,
  updateProjectWaiver
}
